/**
 * Swayy brand design tokens — source: SWAYY_ADMIN_THEME_GUIDE.MD
 *
 * Shell: white AppBar + slate sidebar (classic elegant contrast).
 * Pine used for accents only (avatar, active nav).
 */
export const swayyColors = {
  pine: "#0BB6AE",
  pineHover: "#0AA69F",
  pineActive: "#099690",
  pineLight: "#E5F9F7",
  deepGreen: "#005154",
  deepGreenLight: "#0A6E71",
  /** Slate-900 — clean contrast with white navbar */
  sidebarBg: "#0F172A",
  cloud: "#DDF2F9",
  pageBg: "#F7FCFF",
  white: "#FFFFFF",
  textPrimary: "#005154",
  textSecondary: "#4A6B6D",
  textOnChrome: "#E2E8F0",
  textOnChromeMuted: "#94A3B8",
  border: "#C9E4EC",
  success: "#1EA672",
  warning: "#D97706",
  danger: "#DC2626",
  info: "#0BB6AE",
  /** Dialog / popup overlay — Deep Green at 10% (brand contrast color). */
  overlay: "rgba(0, 81, 84, 0.1)",
} as const;

export const swayyRadii = {
  xs: "4px",
  sm: "6px",
  md: "10px",
  lg: "16px",
  xl: "24px",
  full: "9999px",
} as const;

export const swayyFont =
  "'DM Sans', system-ui, -apple-system, sans-serif";

export const swayyType = {
  xs: "12px",
  sm: "14px",
  base: "16px",
  lg: "18px",
  xl: "20px",
  "2xl": "24px",
  "3xl": "30px",
  "4xl": "36px",
} as const;
